import "./AboutImage.css";

export default function AboutImage({ image, imageAlt }) {
  return (
    <div className="about-preview__photo-frame reveal-on-scroll reveal-on-scroll--left reveal-delay-1">
      <img
        src={image}
        alt={imageAlt || "Dionara Krause"}
        className="about-preview__photo"
      />
    </div>
  );
}